import { Stack } from '@rossum/ui/material';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { DeleteAccountSection } from '../components/DeleteAccountSection';
import { PersonalInformationForm } from '../components/PersonalInformationForm';

export const PersonalSettingsPage = () => {
  return (
    <Stack spacing={4}>
      <PersonalInformationForm />
      <ChangePasswordForm />
      <DeleteAccountSection />
    </Stack>
  );
};
